module.exports = __webpack_public_path__ + "img/style_w_2.e3e9c1bc.png";